module.exports = __webpack_public_path__ + "img/ic_comment.d0f5caec.svg";